// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"AcceptCheckbox_checkboxContainer__sy0vr","labelText":"AcceptCheckbox_labelText__1F1al"};